import * as React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from '@edreamsodigeo/frontend-core';
import { AppBrokenFlowModal } from '../shell/AppBrokenFlowModal';
export default function Container({
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBrokenFlowModal, null), /*#__PURE__*/React.createElement(ErrorBoundary, {
    name: "global"
  }, children));
}
Container.propTypes = {
  children: PropTypes.node.isRequired
};